export default "__VITE_ASSET__DM4O7Nrj__"